import { Pipe, PipeTransform } from '@angular/core';
import {RulesService} from '../rules.service';

@Pipe({
  name: 'toThingName'
})
export class ThingNamePipe implements PipeTransform {

  constructor(private ruleService: RulesService) {
  }
  transform(value: any, args?: any): any {
    if (!value) {
      return;
    }
   const thing = this.ruleService.getThing(value);
   const name = (thing && thing.name) ? thing.name : null;
   return name;
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/pipes/thing-name.pipe.ts